import { Id, PagedSingleSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { newsletterService } from "../api/newsletterService";

interface Props {
	applicationId: Id;
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

export const EmailListSelectField: FC<Props> = ({ applicationId, name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			getLabel={(o) => o.name}
			fetchConfig={laravelSelectFetchConfig(newsletterService.emailListsKey(applicationId), (search, page) =>
				newsletterService.lists(applicationId, search, page).then((r) => r.data),
			)}
		/>
	);
};
